import axios from 'axios';

import core from '../dev/js/core/core';

const Translate = component => {
	let translateURL = 'add_translations.html';
	

	function wrapper() {
		const phrases = JSON.parse(localStorage.getItem('lang'));
		const toTranslate = [];

		const addTranslations = phrase => {
			toTranslate.push(phrase);

		axios.post(translateURL, { token: core.getSimpleToken(), phrase : phrase});

			return `el_${phrase}`;
		};

		let props = [...arguments].splice(0).reduce((result, argumentsObj) => {
			for (let arg in argumentsObj) {
				result = {...result, [arg]: argumentsObj[arg]};
			}

			return result;
		}, {
			tr: JSON.parse(localStorage.getItem('lang')),
			translate: phrase => (phrases[phrase] == undefined || phrases[phrase] == '') ? addTranslations(phrase) : phrases[phrase]
		});

		return component(props);
	};


	return wrapper;

};

export {Translate}


// WEBPACK FOOTER //
// ../hoc/translate.js